import {
  maxLengthRule,
  minLengthRule,
  requiredRule,
  useFormControl,
  type FormControlProps,
} from "@mongez/react-form";
import { cn } from "~/shared/lib";
import { ErrorInput } from "./ErrorInput";
import { LabelInput } from "./LabelInput";

export type TextareaInputProps = FormControlProps & {
  rows?: number;
  classes?: {
    wrapper?: string;
    label?: string;
    input?: string;
    error?: string;
  };
};

export function TextareaInput({
  className,
  classes,
  rules = [],
  label,
  ...props
}: TextareaInputProps) {
  const { id, error, type, value, changeValue, name, otherProps } =
    useFormControl({
      ...props,
      rules: [requiredRule, minLengthRule, maxLengthRule, ...rules],
    });

  return (
    <div className={cn("relative flex flex-col gap-2", classes?.wrapper)}>
      <LabelInput
        htmlFor={id}
        required={props.required}
        className={cn(classes?.label, error && "text-red-500")}
      >
        {label}
      </LabelInput>
      <textarea
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={(e) => changeValue(e.target.value)}
        {...otherProps}
        className={cn(
          "focus:border-primary-500 focus:ring-primary-default w-full rounded-2xl border border-black bg-transparent px-6 py-4 text-xs text-black focus:ring-1 focus:outline-none sm:text-sm lg:text-base",
          error && "border-red-500",
          classes?.input,
        )}
      />
      <ErrorInput className={classes?.error}>{error}</ErrorInput>
    </div>
  );
}
